/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Altersteilzeitpassiv2Inputs */



/**

* @param {_Class_Altersteilzeitpassiv2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_altersteilzeitpassiv2 = /** @type {((inputs?: _Class_Altersteilzeitpassiv2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Altersteilzeitpassiv2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Altersteilzeit Passiv")
});
export { _class_altersteilzeitpassiv2 as "_class_AltersteilzeitPassiv" }